import { render, staticRenderFns } from "./clickBilibili.vue?vue&type=template&id=7555c732&scoped=true"
import script from "./clickBilibili.vue?vue&type=script&lang=js"
export * from "./clickBilibili.vue?vue&type=script&lang=js"
import style0 from "./clickBilibili.vue?vue&type=style&index=0&id=7555c732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7555c732",
  null
  
)

export default component.exports